import React from 'react';
import { motion } from 'framer-motion';

export default function Square({ value, num, onClick, teams, delay, isComputerTarget = false }) {
  let stateClass = 'board-square-empty';
  
  if (value === 1) {
    stateClass = 'board-square-red';
  } else if (value === 2) {
    stateClass = 'board-square-blue';
  }

  const variants = {
    hidden: { 
      scale: 0.5, 
      opacity: 0, 
      rotateX: 90,
    },
    visible: { 
      scale: 1, 
      opacity: 1, 
      rotateX: 0,
      transition: { delay, duration: 0.8, type: "spring", bounce: 0.5 }
    }
  };

  return (
    <motion.button
      variants={variants}
      initial="hidden"
      animate="visible"
      whileHover={{ scale: value === 0 ? 1.05 : 1, zIndex: 20 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      disabled={value !== 0}
      className={`board-square ${stateClass} w-full h-full relative transition-colors duration-300 flex items-center justify-center overflow-hidden aspect-square min-w-0`}
    >
      <span className="board-square-number">
        {num}
      </span>

      {isComputerTarget && value === 0 && (
        <div className="board-ai-hand-mobile">
          👆
        </div>
      )}

      {value !== 0 && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="board-square-claim-flash" />
      )}
    </motion.button>
  );
}
